import React  from 'react';

export default ({ children }) => <h2>{children}</h2>;